import { render } from "./form-tree-li.vue?vue&type=template&id=edb58736"
import script from "./form-tree-li.vue?vue&type=script&lang=js"
export * from "./form-tree-li.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__